import { render, staticRenderFns } from "./InviteeList.vue?vue&type=template&id=6854707c&"
import script from "./InviteeList.vue?vue&type=script&lang=js&"
export * from "./InviteeList.vue?vue&type=script&lang=js&"
import style0 from "./InviteeList.vue?vue&type=style&index=0&id=6854707c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports